<template>
  <div
    class="component-collection-card card-sm-shadow flex-column item"
  >
    <b-card
      overlay
      tag="b-link"
      :title="item.title"
      :img-src="fileUrl(item.imageUrl+'?w=350')"
      :img-alt="item.title"
      :to="'/collection/'+item.id"
      img-top
      class="no-underline border-0 text-center text-white text-shadow"
      title-tag="h5"
      body-class="d-flex align-items-end justify-content-center"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GameCollectionCard',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    })
  }
}
</script>
